/**
 * Tablet platform breakpoint condition
 * @returns boolean
 */
const isTablet = () => {
    if(window.breakpoints){
        return window.breakpoints.mdAndDown;
    }

    return false;
}

export default isTablet;